<template>
  <router-view></router-view>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { Event } from "vue-tables-2";
import Idle from "idle-js";

export default {
  name: "app",
  computed: {
    ...mapGetters({
      user: "getUser",
    })
  },
  methods: {
    ...mapActions({
      refreshUser: "refreshUser",
      refreshUserBalance: "refreshUserBalance",
      refreshShipsurance: "refreshShipsurance",
      refreshNotification: "refreshNotification",
      refreshCarrierRules: "refreshCarrierRules",
      refreshRecipients: "refreshRecipients",
      refreshShippingServices: "refreshShippingServices",
      refreshEcommerceCount: "refreshEcommerceCount",
      refreshImportCount: "refreshImportCount",
    }),
    async test() {
      console.log("TEst: hellow orld");
    },
  },
  async created() {
    let vm = this;

    try {
      // console.log("APP CREATED");
      const response = await this.refreshUser();
      // Heartbeat
      let heartbeat = null;
      let notification = null;

      let idle = new Idle({
        startAtIdle: true,
        onIdle: () => {
          clearInterval(heartbeat);
          clearInterval(notification);
        },
        onActive: () => {
          heartbeat = setInterval(() => {
            if (!_.isEmpty(this.user)) {
              try {
                this.refreshUserBalance();
              } catch (e) {
                window.location = "/#/auth/login";
              }
            }
          }, 30 * 1000);
        },
        onShow: () => {
          notification = setInterval(() => {
            this.refreshNotification();
          }, 60 * 1000);
        },
      });
      idle.start();
    } catch (e) {
      //window.location = '/';
      console.error("APP ERROR", e);
    }
    this.refreshUserBalance();
    this.refreshShippingServices();
    this.refreshCarrierRules();
    this.refreshRecipients();
    this.refreshNotification();
    this.refreshShipsurance();
    this.refreshEcommerceCount();
    this.refreshImportCount();
  }
};
</script>

<style lang="scss">
/* Import Poppins Font */
/*@import '~poppins/css/poppins.css';*/
.VueTables--client {
  .table-responsive {

    // max-height: 60vh !important;
    .ps__rail-x,
    .ps__rail-y {
      background-color: white !important;
      opacity: 1 !important;
    }
  }

  .VuePagination {
    padding-top: 1rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/App.vue